import { useTranslation } from 'react-i18next';
import { ApiError } from './api';

/**
 * Translate an error into something a person can act on.
 *
 * The server returns stable codes rather than prose, so the message shown is
 * always in the user's language — and the `details` a code carries (a credit
 * shortfall, a suggested root domain) are interpolated into it.
 */
export function useApiError() {
  const { t } = useTranslation();

  return (error: unknown): string => {
    if (error instanceof ApiError) {
      return t(`error.${error.code}`, {
        defaultValue: t('error.UNKNOWN_ERROR'),
        ...(error.details ?? {}),
      });
    }
    if (error instanceof Error && error.message === 'Failed to fetch') {
      return t('error.INTERNAL_ERROR');
    }
    return t('error.UNKNOWN_ERROR');
  };
}
